import {post} from '../script/serviceApiPost';

export default{
  async findPageByWhere(dataRow: any) {
    const result = await post('tbInviteCode/findPageByWhere', dataRow);
    return result;
  },
  async add(dataRow: any) {
    const result = await post('tbInviteCode/add', dataRow);
    return result;
  },
  async delete(dataRow: any) {
    const result = await post('tbInviteCode/delete', dataRow);
    return result;
  },
};
